import * as React from "react"
import { theme } from "../theme.css"
import * as styles from "./soon.css"
import Layout from "../components/layout"
import { TColor, TAsset } from "../types"
import { graphql, useStaticQuery } from 'gatsby'

interface Background {
  overlayColor?: string | TColor,
  overlayOpacity: string
  image: {
    id: string
    title: string
    localFile?: {
      childImageSharp?: {
        gatsbyImageData?: any
      }
    }
  }
}

export default function Soon() {
  const data = useStaticQuery(
    graphql`
      query {
        background: file(relativePath: { eq: "coming-soon.jpg" }) {
          childImageSharp {
            gatsbyImageData(
              width: 2000
              placeholder: BLURRED
              formats: [AUTO]
            )
          }
        }
      }
    `
  )
  const background: Background = { 
    image: {
      id: "404",
      title: "404 Background",
      localFile: data.background,
    },
    overlayColor:  theme.colors.bumberBlue,
    overlayOpacity: "0.2",
  }
  return (
    <Layout background={background} empty={true} location="/">
      <div style={{ 
        position: "absolute", 
        flexDirection: "column",
        top: 0, left: 0, bottom: 0, right: 0, 
        display: "flex", 
        textAlign: "center",
        justifyContent: "center", 
        alignItems: "center" 
      }}>
        <h1 className={styles.soonText}>Bumbershoot<br />isn't anything<br />without you</h1>
      </div>
    </Layout>
  )
}